module.exports = __webpack_public_path__ + "static/media/why4.da3277d9.png";